import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const AIStudyTools: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="Free AI Study Tools 2025 - Flashcards, Quizzes, Notes | YouWo AI"
      metaDescription="Discover the best free AI study tools for students. Create flashcards, generate quizzes, transcribe lectures, and summarize PDFs. All-in-one AI learning platform."
      keywords="ai study tools, free study tools, ai learning tools, student ai tools, study app, ai education tools, online study tools"
      canonicalUrl="https://youwo.ai/tools/ai-study-tools"
      // Hero
      headline="Free AI Study Tools for Every Student"
      subheadline="Stop wasting time on manual study prep. YouWo AI's AI tools create flashcards, quizzes, summaries, and notes automatically from any content."
      heroIcon="lucide:sparkles"
      heroIconColor="text-violet-500"
      heroIconBg="bg-violet-50"
      // Problem/Solution
      problemTitle="Study Prep Takes Too Long"
      problemDescription="Hours spent creating flashcards, writing notes, and making practice tests. That's time you should spend actually learning. Most study apps just store your work - they don't help create it."
      solutionTitle="AI Does the Prep Work"
      solutionDescription="YouWo AI's suite of AI tools handles the busywork: upload a PDF and get flashcards in seconds, record a lecture and get organized notes, paste any text and get a practice quiz."
      // Features
      features={[
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "All tools support over 100 languages with automatic detection.",
        },
        {
          icon: "lucide:clock",
          title: "Clickable Timestamps",
          description: "Jump to any moment in recordings and videos with timestamps.",
        },
        {
          icon: "lucide:layers",
          title: "Active Recall Flashcards",
          description: "Generate flashcards using active recall - the most effective learning technique.",
        },
        {
          icon: "lucide:help-circle",
          title: "AI Quiz Generator",
          description: "Create practice tests with multiple choice, true/false, and short answer questions.",
        },
        {
          icon: "lucide:file-text",
          title: "PDF Summarizer",
          description: "Turn documents into summaries with page references.",
        },
        {
          icon: "lucide:youtube",
          title: "YouTube Summarizer",
          description: "Extract key points from educational videos with clickable timestamps.",
        },
      ]}
      // CTA
      ctaText="Try All Tools Free"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "View All Tools", href: "/tools", icon: "lucide:grid" },
        { name: "Quizlet Alternative", href: "/tools/quizlet-alternative", icon: "lucide:layers" },
        { name: "Anki Alternative", href: "/tools/anki-alternative", icon: "lucide:repeat" },
        { name: "Notability Alternative", href: "/tools/notability-alternative", icon: "lucide:edit-3" },
      ]}
    />
  );
};

export default AIStudyTools;
